import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles1 from "./PurchaseHistoryList.module.css";
import styles from "./PurchaseDetails.module.css";
import PurchaseDetailsFirstSection from "./PurchaseDetailsFirstSection";
import PurchaseDetailsSecondSection from "./PurchaseDetailsSecondSection";
import useAxios from "../Hooks/useAxios";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
const PurchaseDetails = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const [orderdetails, setOrderDetails] = useState(null);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const params = queryString.parse(location.search);
  const id = params.id;
  const [orderId, setOrderId] = useState(parseInt(id));
  useEffect(() => {
    axios
      .get(backend_base + "/shop/purchase/history/details/" + orderId)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Successfull order details", res.data);
          setOrderDetails(res.data);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [orderId]);

  const handleClickRightSliderIcon = () => {
    setOrderId((prevId) => prevId + 1);
    navigate(`/purchase-history/details?id=${orderId + 1}`);
  };
  const handleClickLeftSliderIcon = () => {
    setOrderId((prevId) => (prevId === 1 ? prevId : prevId - 1));
    if (orderId !== 1) {
      navigate(`/purchase-history/details?id=${orderId - 1}`);
    } else {
      alert("you have reached the end.");
    }
  };

  return (
    <>
      <Header />
      <div>
        <div className={styles.purchaseDetails}>
          <h6 className={styles.title}>履歴確認</h6>
        </div>
        {orderdetails && (
          <div>
            <PurchaseDetailsFirstSection
              data={orderdetails}
              handleClickRightSliderIcon={handleClickRightSliderIcon}
              handleClickLeftSliderIcon={handleClickLeftSliderIcon}
            />
            <PurchaseDetailsSecondSection data={orderdetails} />
          </div>
        )}
      </div>
      <div
        className={styles1.btn1}
        style={{
          cursor: "pointer",
          margin: "100px auto",
          width: "200px",
          height: "40px",
        }}
        onClick={() => navigate("/check-history/")}
      >
        戻る
      </div>
      <Footer />
    </>
  );
};

export default PurchaseDetails;
